/* eslint-disable sort-keys */
import {
    COUNTRY,
    DRINK_CATEGORY,
    DRINK_TYPE,
    MANUFACTURER,
    NET_VOLUME,
    REGION,
    TEMPERATURE_FROM,
    TEMPERATURE_TO,
} from 'modules/product-card/constants/characteristics';

const HEADER = [COUNTRY, REGION, MANUFACTURER, NET_VOLUME, DRINK_TYPE];
const DETAILED = [DRINK_CATEGORY, TEMPERATURE_FROM, TEMPERATURE_TO];
const TABLET = [...HEADER, ...DETAILED];

const DETAILED_SOK = [TEMPERATURE_FROM, TEMPERATURE_TO];
const TABLET_SOK = [...HEADER, ...DETAILED_SOK];

export const VODA_CHARACTERISTICS = {
    HEADER,
    DETAILED,
    TABLET,
};

export const SOK_CHARACTERISTICS = {HEADER, DETAILED: DETAILED_SOK, TABLET: TABLET_SOK};
